var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCell15(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 7.75,
    width: 2,
    height: 11,
    rx: 1,
    fill: "white",
    fillOpacity: 0.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 9.25,
    width: 2,
    height: 9.5,
    rx: 1,
    fill: "white",
    fillOpacity: 0.25
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 10.75,
    width: 2,
    height: 8,
    rx: 1,
    fill: "white",
    fillOpacity: 0.25
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 12.25,
    width: 2,
    height: 6.5,
    rx: 1,
    fill: "white",
    fillOpacity: 0.25
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 13.75,
    width: 2,
    height: 5,
    rx: 1,
    fill: "white",
    fillOpacity: 0.85
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 5.25H5.5V8.25H6V9.25H5.5V10.75H4.5V9.25H1.5V8.25L4.25 5.25ZM4.5 8.25V6.75L3 8.25H4.5Z",
    fill: "white",
    fillOpacity: 0.85
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 6L11.25 6.75C11.25 6.75 10.7101 6.25 9.75 6.25C8.75 6.25 8 7 8 8C8 9 8.75 9.75 9.75 9.75C10.75 9.75 11 9.25 11 9.25V8.75H10V7.75H12V9.75C12 9.75 11.25 10.75 9.75 10.75C8 10.75 7 9.5 7 8C7 6.5 8 5.25 9.75 5.25C11 5.25 11.75 6 11.75 6Z",
    fill: "white",
    fillOpacity: 0.85
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCell15);
export default __webpack_public_path__ + "static/media/cell15.9749154448c871075a29ad6780864fe9.svg";
export { ForwardRef as ReactComponent };